import React from 'react';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import HeaderThree from "../component/header/HeaderThree";
import FooterOne from "../component/footer/FooterOne";
import TabTwo from "../elements/tab/TabTwo";
import ContactOne from "../elements/contact/ContactOne";
import PortfolioList from "../elements/portfolio/PortfolioList";
import ServiceList from "../elements/service/ServiceList";
import ServiceListTwo from "../elements/service/ServiceListTwo";
import BlogContent from "../elements/blog/BlogContent";
import Helmet from "../component/common/Helmet";

const SlideList = [
    {
        textPosition: 'text-left',
        category: 'Coach Dennis',
        title: 'Hello, I’m <span>Dennis</span> Welcome to my World.',
        description: 'I help talented professionals and organisations cut through the noise, build resilience, and establish a lasting impact.',
        buttonText: '',
        buttonLink: ''
    }
]
const PortfolioLanding = () => {
    const PostList = BlogContent.slice(0 , 3);
    return (
        <div>
            <Helmet pageTitle="Coach DOI" />
            <HeaderThree homeLink="/" color="color-black"/>
            {/* Start Slider Area   */}
            <div id="home" className="fix">
                <div className="slider-wrapper">
                    {/* Start Single Slide */}
                    {SlideList.map((value , index) => (
                        <div className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center bg_image bg_image--25" key={index}>
                            <div className="container">
                                <div className="row d-flex justify-content-between">
                                    <div className="col-lg-4">
                                        <div className={`inner ${value.textPosition}`}>
                                            {/* {value.title ? <p className="" dangerouslySetInnerHTML={{__html: value.title}}></p> : ''} */}
                                            {value.description ? <p className="description">{value.description}</p> : ''}
                                            {value.buttonText ? <div className="slide-btn"><a className="btn-sm rn-button-style--2 btn-primary-color" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className={`inner text-right`}>
                                            {/* <p className="" dangerouslySetInnerHTML={{__html: value.title}}></p> */}
                                            <p className="description">
                                                In an ever-evolving global business landscape, the right transformative strategies, delivered with clarity and authenticity, can transform careers and organisations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* End Single Slide */}
                </div>
            </div>
            {/* End Slider Area   */} 

            {/* Start About Area */}
            <div id="abou" className="fix">
                <div className="about-area ptb--120  bg_color--1">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h3 className="title">Hi, I am Dennis</h3>
                                            <p className="description">I am the author of <b><i>Stumbling Towards Clarity:</i></b> A book about resilience and self-discovery. I write life advice that is relatable, time tested and actually works. Some people say I am brutally honest, others say I inspire them. Read on and decide for yourself.</p>

                                            <p className="description">Whatever path you took to get here, I am really glad you are here because I am here to help you take charge of your career, break past self-doubt, and build a future you are genuinely excited about. </p>

                                            <p className="description"><b>Let's make it happen—book a 45-minute clarity call today.</b></p>

                                            <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href="https://calendly.com/dennisoge/clarity-call" target="_blank">Calendly</a></div>
                                        </div>
                                        {/* <div className="row mt--30">
                                            <TabTwo tabStyle="tab-style--1" />
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className="row row--35 align-items-center mt--30">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/book.jpeg" alt="About Images"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h3 className="title">Stumbling Towards Clarity</h3>
                                            <p className="description"><b><i>"Stumbling Towards Clarity"</i></b> is more than just an intriguing title, it is a transformative journey of resilience, determination, and unwavering optimism. This powerful mantra embraces the notion that every setback is a stepping stone towards a clearer understanding of oneself and one's purpose.</p>
                                                
                                            <p className="description"><b>"Stumbling Towards Clarity" is available now (paperback and Kindle) and as an Ebook on Mainstack and Selar.</b></p>

                                            <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href="/stumbling-towards-clarity">Tell Me More</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* End About Area */}

            {/* Start Service Area  */}
            <div id="coaching" className="fix">
                <div className="service-area creative-service-wrapper ptb--120 bg_color--5">
                    <div className="container">
                        <div className="row mb-3">
                            <div className="col-lg-12">
                                <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                    <h3 className="title">Courses</h3>
                                    {/* <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p> */}
                                </div>
                            </div>
                        </div>
                        <div className="row creative-service">
                            <ServiceListTwo item="4" column="col-lg-3 col-md-6 col-sm-6 col-12 text-left" />
                        </div>
                    </div>
                </div>

                <div className="service-area creative-service-wrapper bg_color--5 mb--30" >
                    <div className="container">
                        <div className="row mb-3">
                            <div className="col-lg-12">
                                <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                    <h3 className="title">Coaching Services</h3>
                                    {/* <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p> */}
                                </div>
                            </div>
                        </div>
                        <div className="row creative-service">
                            <ServiceList item="3" column="col-lg-4 col-md-6 col-sm-6 col-12 text-left" />
                        </div>
                    </div>
                </div>
            </div>
            {/* End Service Area  */}

            {/* Start COntact Area */}
            {/* <div id="contact" className="fix">
                <div className="rn-contact-area ptb--120 bg_color--1">
                    <ContactOne />
                </div>
            </div> */}
            {/* End COntact Area */}

            <FooterOne />
            {/* Start Back To Top */}
            <div className="backto-top">
                <ScrollToTop showUnder={160}>
                    <FiChevronUp />
                </ScrollToTop>
            </div>
            {/* End Back To Top */}
        </div>
    )
}

export default PortfolioLanding;
